import { InjectionToken } from '@angular/core';
import { IRedocOauth2Config } from '@redocco/oauth2-redoc-connect';

export const OAUTH2_CONFIG = new InjectionToken<IRedocOauth2Config>('OAUTH2_CONFIG');
